import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { keycloak } = useKeycloak();
  console.log("keycloak");
  console.log(keycloak.realmAccess.roles);
//  .includes("banana")

  return keycloak.authenticated ? children : <Navigate to="/" />;
}
